import LinkedInPerformancePage from "../features/crm/LinkedInPerformancePage";

export default function CrmLinkedInPerformanceRoute() {
  return <LinkedInPerformancePage />;
}
